import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export type ErrorTextProps = {
  id?: string;
  children: ReactNode;
  className?: string;
};

/** Ошибка валидации поля — только под полем ввода. */
export function ErrorText({ id, children, className }: ErrorTextProps) {
  return (
    <p
      id={id}
      role="alert"
      className={cn('mt-1 text-xs text-amber-700 dark:text-amber-400', className)}
    >
      {children}
    </p>
  );
}
